// @flow

export const switchClientDropdownActions = {
  TOGGLE_SWITCH_CLIENT_DROPDOWN: 'TOGGLE_SWITCH_CLIENT_DROPDOWN',
  SELECTED_CLIENT: 'SELECTED_CLIENT'
};

export const toggleSwitchClientDisplay = (data: boolean) => ({
  type: switchClientDropdownActions.TOGGLE_SWITCH_CLIENT_DROPDOWN,
  payload: data
});

export const getClientsForSwitchClientOption = (data: Object) => ({
  type: switchClientDropdownActions.SELECTED_CLIENT,
  payload: data
});
